import elDynamicFormDesign from './index.vue'

const install = (Vue) => {
    Vue.component(elDynamicFormDesign.name, elDynamicFormDesign)
}

if (window && window.Vue) {   //通过`script`标签引入的情况，在组件内部完成组件注册。
    window.Vue.use(install)
}

export default install